<template>
	<header class="header" :class="{ 'header--open': isMenuOpen, 'header--scrolled': isScrolled }">
		<div class="header__wrapper page-wrapper">
			<router-link :to="$locale.toRouteLinkProp('home')" class="header__logo-wrapper">
				<img :src="require('@/assets/' + $t('nav.headerLogo'))" alt="" class="header__logo"/>
			</router-link>
			<div class="header__toggle" @click="toggleMenu"><span class="header__toggle-inner"></span></div>
			<nav class="header__nav">
				<ul class="menu menu--secondary">
					<li class="menu__item">
						<router-link :to="$locale.toRouteLinkProp('news')" class="menu__link">{{ $t("nav.news") }}</router-link>
					</li>
					<li class="menu__item">
						<a href="https://corelogic.wd5.myworkdayjobs.com/USCAN?locations=e0052c9790670137e67fb5f5cc074144" target="_blank" class="menu__link">{{ $t("nav.careers") }}</a>
					</li>
					<li class="menu__item">
						<a :href="$t('general.mobilePortalLoginLink')" target="_blank"  class="menu__link">{{ $t("nav.mobilePortal") }}</a>
					</li>
					<li class="menu__item">
						<dropdown :toggle-text="$t('general.currentLanguage')" :values="dropdownLanguages"></dropdown>
					</li>
					<li class="menu__item menu__item--localeFlag" v-if="$i18n.locale != 'en-US'">
						<img class="flag flag--ca" src="@/assets/canada-flag.svg">
					</li>
					<li class="menu__item menu__item--localeFlag" v-else>
						<img class="flag flag--usa" src="@/assets/usa-flag.svg">
					</li>
				</ul>
				<ul class="menu menu--main">
					<li class="menu__item">
						<dropdown :toggle-text="$t('nav.forAgents')" :values="dropdownSolutions"></dropdown>
					</li>
					<li class="menu__item" v-if="$i18n.locale != 'fr-CA'">
						<router-link :to="$locale.toRouteLinkProp('associations')" class="menu__link">{{ $t("nav.forAssociations") }}</router-link>
					</li>
					<li class="menu__item">
						<router-link :to="$locale.toRouteLinkProp('about')" class="menu__link">{{ $t("nav.about") }}</router-link>
					</li>
					<li class="menu__item">
						<router-link :to="$locale.toRouteLinkProp('contact')" class="menu__link">{{ $t("nav.contact") }}</router-link>
					</li>
					<li class="menu__item menu__item--phone">
						<a :href="$t('support.phoneHtml')" class="menu__link">{{ $t('support.phone') }}</a>
					</li>
					<li class="menu__item">
						<a :href="$t('general.crmLoginLink')" target="_blank" class="button button--small">{{ $t("general.login") }}</a>
					</li>
				</ul>
			</nav>
		</div>
		<div class="header__curtain" @click="toggleMenu"></div>
	</header>
</template>

<script>
import Dropdown from '@/components/utils/Dropdown.vue'

export default {
	components: { Dropdown },
	created () {
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed () {
		window.removeEventListener('scroll', this.handleScroll);
	},
	mounted () {

	},
	data () {
		return {
			isMenuOpen: false,
			isScrolled: false
		}
	},

	computed: {
		dropdownLanguages() {
			return [
				{ text: "USA", route: this.$locale.toRouteLinkProp(this.$route.name, 'en', 'us') },
				{ text: "CA (EN)", route: this.$locale.toRouteLinkProp(this.$route.name, 'en', 'ca') },
				{ text: "CA (FR)", route: this.$locale.toRouteLinkProp(this.$route.name, 'fr', 'ca') }
			];
		},
		dropdownSolutions() {
			return [
				{ text: "Prospects CRM", route: this.$locale.toRouteLinkProp('crm') },
				{ text: this.$t("mobileName"), route: this.$locale.toRouteLinkProp('mobile') },
				// { text: 'Prospects ' + this.$t('edm.name'), route: this.$locale.toRouteLinkProp('edm') }
			];
		},
		contactRoute() {
			return Object.assign({}, this.$locale.toRouteLinkProp('support'), { hash: 'contact-form'});
		}
	},
	methods: {
		toggleMenu (force) {
			this.isMenuOpen = typeof(force) === 'object' ? (!this.isMenuOpen) : force;
			document.querySelector("body").style.overflow = this.isMenuOpen ? "hidden" : "visible";
			document.querySelector("body").style.position = this.isMenuOpen ? "fixed" : "static";
			document.querySelector("body").style.width = this.isMenuOpen ? "100%" : "auto";
		},
		handleScroll () {
			this.isScrolled = window.scrollY > 0;
		}
	},
	watch: {
		'$route' () {
			this.toggleMenu(false);
		}
	}
};
</script>
<style scoped>
	.header { box-sizing: border-box; border-bottom: 1px solid #dedede; padding: 10px 0; position: sticky; top: 0; z-index: 9999; background: white; }
	.header--scrolled { height: 55px; position: fixed; width: 100%; }
	.header--scrolled:not(.header--open) .menu--secondary { visibility: hidden; max-height: 0; overflow: hidden; padding-bottom: 0; }
	.header--scrolled .header__logo-wrapper { align-self: auto; }
	.header__wrapper { display: flex; flex-wrap: wrap; align-items: center; }
	.header__logo-wrapper { align-self: center; }
	.header__logo { width: 320px; }
	.header__toggle { display: none; width: 30px; height: 23px; cursor: pointer; position: relative; }
	.header__toggle-inner, .header__toggle-inner::before, .header__toggle-inner::after { width: 100%; height: 3px; display: block; border-radius: 3px; background: #333; transition: all 0.7s ease; }
	.header__toggle-inner { position: absolute; top: calc(50% - 1.5px); }
	.header__toggle-inner::before, .header__toggle-inner::after { content: " "; width: 100%; position: absolute; }
	.header__toggle-inner::before { top: -10px; }
	.header__toggle-inner::after { top: 10px; }
	.header__nav { flex: 1; display: flex; flex-direction: column; align-items: flex-end; }
	.header__curtain { content: " "; position: fixed; left: 100%; top: 55px; height: 100%; width: 100%; z-index: 9998; transition: left .36s ease-in,background-color .24s ease-in .48s; }

	.menu--secondary { max-height: 300px; transition: max-height 400ms cubic-bezier(0, 0.6, 0.6, 1), padding-bottom 400ms cubic-bezier(0, 0.6, 0.6, 1); padding-bottom: 20px; color: #868686; font-size: 1.3rem; }
	.menu--main { text-transform: uppercase; font-size: 1.5rem; color: #333333; font-weight: 600; }
	.menu__item--phone { margin-left: 50px; }
	.menu__item--phone::before { content: "●"; position: absolute; left:-30px; color: #c51b1e; z-index: -1; }

	.menu__item--localeFlag { margin-left: 10px; }
	.flag { max-width: 20px; }
	.flag--ca {}
	.flag--usa {}

	@media (max-width: 1300px) {
		.menu--main { font-size: 1.35rem; }
	}

	@media (max-width: 1100px) {
		.menu__item--phone { display: none; }
	}

	@media (max-width: 900px) {
		.header { height: 63px; display: flex; }
		.header__logo-wrapper { flex: 1; }
		.header__toggle { display: block; }
		.header__nav { width: 85%; height: 100%; overflow-y: auto; align-items: flex-start; z-index: 9999; position: fixed; top: 55px; left: 100%; background: white; transition: left .36s ease-in, background-color .24s ease-in .48s; }

		.header--open .header__curtain { left: 0; background-color: rgba(0, 0, 0, 0.6); }
		.header--open .header__toggle-inner { height: 0; }
		.header--open .header__toggle-inner::before { transform: rotate(45deg); top: 0; }
		.header--open .header__toggle-inner::after { transform: rotate(-45deg); top: 0; }
		.header--open .header__nav { left: 0; }

		.menu { width: 100%; flex-direction: column; align-items: flex-start; }
		.menu__item { font-size: 1.65rem; width: 100%; margin-left:0; padding: 14px 0 14px 30px; border-bottom: 1px solid #e8e8e8; box-sizing: border-box; }
		.menu__item:first-child { padding-left: 30px; }
		.menu--secondary { order: 2; }
	}

</style>
<style>
	@media (max-width: 900px) {
		.header .dropdown__menu { position: static; display: flex; box-shadow: none; flex-direction: column; margin-top: 0; padding-left: 0; padding-top: 15px; padding-bottom: 0; }
		.header .dropdown__item { padding: 10px 0; border-bottom: 1px solid #e8e8e8; }
		.header .dropdown__item:last-child { padding-bottom: 0; border-bottom: none; }
	}
</style>
